import { takeLatest, call, put } from 'redux-saga/effects';

import * as api from './services';
import * as cn from './constants';
import * as a from './actions';
import * as fm from './formatter';

import scorecardDataTransformer from 'transformers/scorecardDataTransformer';

/**
 * Fetches combined daily_summary API (score_card + summary), then updates both scores and dailySummary.
 */
function* fetchDailySummary({ payload }) {
  yield put({ type: cn.SCORE_INIT });

  try {
    const { data: responseData, status } = yield call(
      api.getDailySummary,
      payload,
    );

    if (status === 200 || (status === 206 && responseData)) {
      const { error_message } = responseData;

      if (error_message) {
        yield put(a.getScoresError(error_message));
        yield put(a.getDailySummaryError(error_message));
      } else {
        const scoreCardPayload = fm.scoreCardFromDailySummaryResponse(responseData);
        const formattedScores = scorecardDataTransformer(scoreCardPayload, 'mmpay');
        yield put(a.getScoresSuccess(formattedScores));

        const summaryPayload = responseData.summary ?? responseData;
        const formattedSummary = fm.dailySummaryFormatter(summaryPayload);
        yield put(a.getDailySummarySuccess(formattedSummary));
      }
    } else {
      yield put(a.getScoresError('Something went wrong'));
      yield put(a.getDailySummaryError('Something went wrong'));
    }
  } catch (e) {
    yield put(a.getScoresError('Something went wrong'));
    yield put(a.getDailySummaryError('Something went wrong'));
  }
}

function* fetchTransactions({ payload }) {
  try {
    const { data: responseData, status } = yield call(
      api.getTransactions,
      payload,
    );

    if (status === 200 || (status === 206 && responseData)) {
      const errorMessage = Array.isArray(responseData)
        ? null
        : responseData?.error_message;

      if (errorMessage) {
        yield put(a.getTransactionsError(errorMessage));
      } else {
        const list = Array.isArray(responseData) ? responseData : [];
        const formattedData = fm.transactionsFormatter(list);
        yield put(a.getTransactionsSuccess(formattedData));
      }
    }
  } catch (e) {
    yield put(a.getTransactionsError('Something went wrong'));
  }
}

export default function* watchMmpayContainer() {
  yield takeLatest(cn.DAILY_SUMMARY_INIT, fetchDailySummary);
  yield takeLatest(cn.TRANSACTIONS_INIT, fetchTransactions);
}
